export default {
	posts: 'Manage Story List',
	category: 'Manage Category',
	theme: 'Manage Theme',
	etc: 'Miscellaneous Settings',
	config: 'Edit Config File',
};
